import { Link, useSearch } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { DirectoryView } from "./directory/DirectoryView";

/**
 * Tools directory area (route: /tools). Like the expert directory, tools are
 * reached contextually from a piste d'action (the Outils icon on an action-plan
 * action links here with ``?action=<id>``). Without an action there is nothing
 * to browse, so we point the user back to the action plan.
 */
export function ToolsArea() {
  const { t } = useTranslation();
  const search = useSearch({ strict: false }) as {
    action?: unknown;
    fav?: unknown;
  };
  const action = typeof search.action === "string" ? search.action : null;
  const favoritesDefault = search.fav === true;

  if (!action) {
    return (
      <div className="mx-auto max-w-2xl">
        <Card>
          <CardHeader>
            <CardTitle>{t("tools.directory.actionRequired.title")}</CardTitle>
            <CardDescription>
              {t("tools.directory.actionRequired.help")}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button asChild>
              <Link to="/action-plans">
                {t("tools.directory.actionRequired.goToPlans")}
              </Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <header className="space-y-1">
        <h1 className="text-3xl font-bold">{t("tools.title")}</h1>
        <p className="text-muted-foreground">{t("tools.subtitle")}</p>
      </header>
      <DirectoryView action={action} favoritesDefault={favoritesDefault} />
    </div>
  );
}
